import Centered from "layouts/auth/types/Centered";
import Card from "components/card";
import React, {useEffect, useState} from "react";
import PinInput from "react-pin-input";
import FixedPlugin from "../../components/fixedPlugin/FixedPlugin";
import {Link, useNavigate} from "react-router-dom";
import {useUserAuth} from "../../context/UserAuthContext";
import InputField from "../../components/fields/InputField";

function Verification() {
    const [errorMessage, setErrorMessage] = useState("");
    const [email, setEmail] = useState("");
    let [password, setPassword] = useState("");
    let [confirmPassword, setConfirmPassword] = useState("");
    const [receivedOtp, setReceivedOtp] = useState("");
    const [accessFromDashboard, setAccessFromDashboard] = useState(false);
    const [minutes, setMinutes] = useState(1);
    const [seconds, setSeconds] = useState(59);
    //const [user ,setuser]=useState("");
    const navigate = useNavigate();

    const CROMPTON_BASE_URL_STRING = process.env.REACT_APP_CROMPTON_SENZE_BASE_URL_STRING;

    const {
        logIn,
        userToken,
        userstate,
        user,
        accesscontrollevel,
        getEmailOtp,
        getMobileOtp,
        verifyEmailOtp,
        verifyMobileOtp,
        resetPassword,
        checkPasswords,
        createAccount,
        loginUsingOtp,
        isValidEmailAddress,
        isValidPassword,
        isValidMobileNumber,
        deleteAccount
    } = useUserAuth();

    useEffect(() => {
        if (sessionStorage.getItem("DAFromWeb") === "1") {
            setAccessFromDashboard(true)
        } else {
            setAccessFromDashboard(false)
        }
        const interval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }

            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(interval);
                } else {
                    setSeconds(59);
                    setMinutes(minutes - 1);
                }
            }
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, [seconds]);

    const handleChangePassword = async (e) => {
        let resetPasswordResponse;
        setErrorMessage("")
        if (sessionStorage.getItem("pageFrom") === "RP") {
            resetPasswordResponse = await resetPassword(sessionStorage.getItem("email"), sessionStorage.getItem("password"), receivedOtp);
            //console.log(resetPasswordResponse)
            if (resetPasswordResponse.status === 200) {
                setErrorMessage("")
                navigate("/")
                //console.log(b)
                //setmessage("")
            } else {
                setErrorMessage(resetPasswordResponse.response.data.message)
            }
        } else {
            e.preventDefault()
            password = document.getElementById('passwordField').value
            confirmPassword = document.getElementById('confirmPassword').value
            //console.log("P:", password)
            //console.log("CP:", confirmPassword)
            //console.log("E:", email)
            if (password !== confirmPassword) {
                setErrorMessage("The passwords do not match. Please try again.")
                //alert("The passwords do not match. Please try again.");
            } else {
                try {
                    if (!isValidPassword(password)) {
                        setErrorMessage("Password is not as per format.")
                    } else {
                        resetPasswordResponse = await resetPassword(email, password, receivedOtp);
                        // console.log(resetPasswordResponse)
                        if (resetPasswordResponse.status === 200) {
                            setErrorMessage("")
                            navigate("/")
                            //console.log(b)
                            //setmessage("")
                        } else {
                            setErrorMessage(resetPasswordResponse.response.data.message)
                        }
                    }

                } catch (error) {
                    setErrorMessage(resetPasswordResponse.response.data.message)
                    // console.log(error)
                }
            }
        }

    }

    const handleCreateAccount = async (email, password) => {
        let createAccountResponse;
        setErrorMessage("")

        try {
            //console.log("Inside create")
            createAccountResponse = await createAccount(email, password)
            //console.log(createAccountResponse)

            if (createAccountResponse.status === 200) {
                //console.log("Inside create")
                setErrorMessage("")
                sessionStorage.setItem("password", "")
                //navigate("/admin/dashboard")
                navigate("/")
                //console.log(b)
                //setmessage("")
            } else {
                setErrorMessage(createAccountResponse.response.data.message)
            }
        } catch (error) {
            //console.log(error)
            setErrorMessage(createAccountResponse.response.data.message)
        }
    }

    const resendOtp = async (e) => {
        e.preventDefault()

        //setEmail(document.getElementById('email').value)
        let email = sessionStorage.getItem("email")
        setEmail(email)

        //console.log(email)

        if (email.includes("@")) {
            if (isValidEmailAddress(email)) {
                try {
                    let otpResponse = await getEmailOtp(email)
                    //console.log(otpResponse)

                    if (otpResponse.status === 200) {
                        setErrorMessage('')
                        setMinutes(1)
                        setSeconds(59)
                    } else {
                        setErrorMessage(otpResponse.response.data.message)
                    }

                } catch (error) {
                    //console.log(error)
                    setErrorMessage(error.response.data.message)
                }
                //console.log("email: ", email + "is valid")
                setErrorMessage("")
            } else {
                setErrorMessage("The email " + email + "  address is not as per format!!!")

            }
        } else {
            if (isValidMobileNumber(email)) {
                setErrorMessage("")
                try {
                    sessionStorage.setItem("email", email)
                    let otpResponse = await getMobileOtp(email)
                    //console.log(otpResponse)

                    if (otpResponse.status === 200) {
                        setErrorMessage('')
                        setMinutes(1)
                        setSeconds(59)
                    } else {
                        setErrorMessage(otpResponse.response.data.message)
                    }

                } catch (error) {
                    //console.log(error)
                    setErrorMessage(error.response.data.message)
                }
                //console.log("mobile: ", email + "is valid")
            } else {
                setErrorMessage("The mobile number " + email + " is not as per format!!!")

            }
        }
    }

    const handleLoginUsingOtp = async (email, receivedOtp) => {
        setErrorMessage("")

        email = sessionStorage.getItem("email")
        setEmail(email)
        let loginWithOtpResponse

        try {
            loginWithOtpResponse = await loginUsingOtp(email, receivedOtp)
            // console.log(loginWithOtpResponse)
            if (loginWithOtpResponse.status === 200) {
                setErrorMessage("")
                sessionStorage.setItem("password", "")
                navigate("/admin/dashboard")
                //console.log(b)
                //setmessage("")
            } else {
                setErrorMessage(loginWithOtpResponse.response.data.message)
            }
        } catch (error) {
            //console.log(error)
            setErrorMessage(loginWithOtpResponse.response.data.message)
        }
    }

    const deleteAccountUsingOtp = async (email, receivedOtp) => {
        setErrorMessage("")

        email = sessionStorage.getItem("email")
        setEmail(email)
        let deleteAccountResponse

        try {
            deleteAccountResponse = await deleteAccount(email, receivedOtp)
            // console.log(loginWithOtpResponse)
            if (deleteAccountResponse.status === 200) {
                setErrorMessage("")
                //sessionStorage.setItem("password", "")
                navigate("/")
                //console.log(b)
                //setmessage("")
            } else {
                setErrorMessage(deleteAccountResponse.response.data.message)
            }
        } catch (error) {
            //console.log(error)
            setErrorMessage(deleteAccountResponse.response.data.message)
        }
    }

    const verifyReceivedOtp = async (e) => {
        // Prevent the default submit and page reload
        e.preventDefault()

        setErrorMessage("")

        let email = sessionStorage.getItem("email")
        setEmail(email)
        let password = sessionStorage.getItem("password")
        let index = email.indexOf("@")
        //console.log(email)
        //console.log(password)
        try {
            if (index === -1) {
                if (sessionStorage.getItem("pageFrom") === "DA") {
                    //console.log(email)
                    await deleteAccountUsingOtp(email, receivedOtp)
                    //console.log(password)
                    //await handleLoginUsingOtp(email, receivedOtp)
                } else {
                    const receivedVerifyResponse = await verifyMobileOtp(email, receivedOtp);
                    //console.log(email)
                    //console.log(password)
                    if (receivedVerifyResponse.status === 200) {
                        setErrorMessage("")
                        //console.log("received 200")
                        if (sessionStorage.getItem("pageFrom") === "FP") {
                            //console.log("Request came from FP")
                            document.getElementById("otpScreen").hidden = true
                            document.getElementById("confirmPasswordDiv").hidden = false

                        } else if (sessionStorage.getItem("pageFrom") === "CA") {
                            //console.log(email)
                            //console.log(password)
                            await handleCreateAccount(email, password)
                        } else if (sessionStorage.getItem("pageFrom") === "RP") {
                            //console.log(email)
                            //console.log(password)
                            await handleChangePassword(email, password)
                        } else if (sessionStorage.getItem("pageFrom") === "LOTP") {
                            //console.log(email)
                            //console.log(password)
                            await handleLoginUsingOtp(email, receivedOtp)
                        }
                        /*await completeSignUp()*/
                    } else {
                        setErrorMessage(receivedVerifyResponse.response.data.message)
                    }
                }

            } else {
                if (sessionStorage.getItem("pageFrom") === "DA") {
                    //console.log(email)
                    await deleteAccountUsingOtp(email, receivedOtp)
                    //console.log(password)
                    //await handleLoginUsingOtp(email, receivedOtp)
                } else {

                    const receivedVerifyResponse = await verifyEmailOtp(email, receivedOtp);
                    //console.log(email)
                    //console.log(password)
                    if (receivedVerifyResponse.status.toString() === "200") {
                        setErrorMessage("")
                        if (sessionStorage.getItem("pageFrom") === "FP") {
                            //console.log(email)
                            //console.log(password)
                            //console.log("Request came from FP")
                            document.getElementById("otpScreen").hidden = true
                            document.getElementById("confirmPasswordDiv").hidden = false

                        } else if (sessionStorage.getItem("pageFrom") === "CA") {
                            //console.log(email)
                            //console.log(password)
                            await handleCreateAccount(email, password)
                        } else if (sessionStorage.getItem("pageFrom") === "RP") {
                            //console.log(email)
                            //console.log(password)
                            await handleChangePassword()
                        } else if (sessionStorage.getItem("pageFrom") === "LOTP") {
                            //console.log(email)
                            //console.log(password)
                            await handleLoginUsingOtp(email, receivedOtp)
                        }
                        //await completeSignUp()
                    } else {
                        setErrorMessage(receivedVerifyResponse.response.data.message)
                    }
                }
            }

        } catch (error) {
            //console.log(error)
        }
    }

    return (
        <div>
            <div id="otpScreen">
                <Centered
                    maincard={
                        <Card
                            extra="max-w-[405px] md:max-w-[550px] h-max mt-32 md:mt-[120px] mx-2.5 md:mx-auto mb-auto pb-2.5 pt-8 md:pt-2.5 px-4 md:!p-[50px]">
                            <FixedPlugin/>
                            {
                                accessFromDashboard &&
                                <Link to="/" className="mt-0 w-max">
                                    <div className="mx-auto flex h-fit w-fit items-center hover:cursor-pointer">
                                        <svg
                                            width="8"
                                            height="12"
                                            viewBox="0 0 8 12"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M6.70994 2.11997L2.82994 5.99997L6.70994 9.87997C7.09994 10.27 7.09994 10.9 6.70994 11.29C6.31994 11.68 5.68994 11.68 5.29994 11.29L0.709941 6.69997C0.319941 6.30997 0.319941 5.67997 0.709941 5.28997L5.29994 0.699971C5.68994 0.309971 6.31994 0.309971 6.70994 0.699971C7.08994 1.08997 7.09994 1.72997 6.70994 2.11997V2.11997Z"
                                                fill="#A3AED0"
                                            />
                                        </svg>

                                        <p className="ml-3 text-sm text-gray-600">Back</p>


                                    </div>
                                </Link>
                            }
                            <br/>
                            <h3 className="mt-1 text-4xl font-bold text-navy-700 dark:text-white">
                                2-Step Verification
                            </h3>
                            <p className="mt-[15px] ml-1 text-[15px] text-gray-600">
                                Enter your Verification code to proceed!
                            </p>
                            {/* verification */}
                            <div className="mt-7 mb-4 flex w-full items-center justify-center">
                                <PinInput
                                    length={4}
                                    initialValue=""
                                    onChange={(value, index) => {
                                    }}
                                    type="numeric"
                                    inputMode="number"
                                    style={{padding: "10px"}}
                                    inputStyle={{
                                        borderWidth: "2px",
                                        width: "75px",
                                        height: "75px",
                                        borderColor: "#E0E5F2",
                                        borderRadius: "16px",
                                        color: "#004c86",
                                        fontSize: "36px",
                                    }}
                                    inputFocusStyle={{borderColor: "#0b83b5", borderWidth: "3px"}}
                                    onComplete={(value, index) => {
                                        setReceivedOtp(value)
                                    }}
                                    autoSelect={true}
                                    regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                                />
                            </div>
                            {/* button */}
                            <button
                                className="w-full rounded-xl bg-[#004c86] py-3 text-base font-medium text-white transition duration-200
                        hover:bg-[#004c86] dark:bg-brand-[#004c86] dark:text-white dark:hover:bg-[#004c86]
                        dark:active:bg-[#004c86]" onClick={verifyReceivedOtp}>
                                Verify
                            </button>
                            <p className="mt-4 text-sm font-medium text-navy-700 dark:text-gray-500">
                                Haven't received it?
                                <span className="text-sm font-medium text-[#004c86] dark:text-white">
              {" "}
                                    {seconds > 0 || minutes > 0 ? (
                                        <span className="text-sm font-bold text-navy-700 dark:text-gray-500">
                                    Resend a new code in {" "}
                                            {minutes < 10 ? `0${minutes}` : minutes}:
                                            {seconds < 10 ? `0${seconds}` : seconds}
                                </span>
                                    ) : (
                                        <span className="text-sm font-bold text-[#004c86] dark:text-white"
                                              onClick={resendOtp}>
                                    Resend a new code
                                </span>
                                    )}
            </span>
                            </p>
                            <span className="errorMessage">
                                {errorMessage}
                            </span>
                        </Card>
                    }
                />
            </div>
            <div id="confirmPasswordDiv" hidden={true}>
                <Centered
                    maincard={
                        <Card
                            extra="max-w-[405px] md:max-w-[550px] h-max mt-32 md:mt-[120px] mx-2.5 md:mx-auto mb-auto pb-2.5 pt-8 md:pt-2.5 px-4 md:!p-[50px]">
                            <FixedPlugin/>
                            <Link to="/senze-3.0" className="mt-0 w-max">
                                <div className="mx-auto flex h-fit w-fit items-center hover:cursor-pointer">
                                    <svg
                                        width="8"
                                        height="12"
                                        viewBox="0 0 8 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M6.70994 2.11997L2.82994 5.99997L6.70994 9.87997C7.09994 10.27 7.09994 10.9 6.70994 11.29C6.31994 11.68 5.68994 11.68 5.29994 11.29L0.709941 6.69997C0.319941 6.30997 0.319941 5.67997 0.709941 5.28997L5.29994 0.699971C5.68994 0.309971 6.31994 0.309971 6.70994 0.699971C7.08994 1.08997 7.09994 1.72997 6.70994 2.11997V2.11997Z"
                                            fill="#A3AED0"
                                        />
                                    </svg>
                                    <p className="ml-3 text-sm text-gray-600">Back</p>
                                </div>
                            </Link>
                            <br/>
                            <h3 className="mt-1 text-4xl font-bold text-navy-700 dark:text-white">
                                Reset Password
                            </h3>
                            <p className="mb-9 ml-1 text-base text-gray-600">
                                {/*Enter New Password*/}
                            </p>

                            {/* verification */}
                            <InputField
                                variant="auth"
                                extra="mb-3"
                                label="Password*"
                                placeholder="Password"
                                id="passwordField"
                                type="password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                            />

                            {/* Password */}
                            <InputField
                                variant="auth"
                                extra="mb-3"
                                label="Confirm Password*"
                                placeholder="Confirm Password"
                                id="confirmPassword"
                                type="password"
                                value={confirmPassword}
                                onChange={e => setConfirmPassword(e.target.value)}
                            />
                            {/* button */}

                            <button
                                className="w-full rounded-xl bg-[#004c86] py-3 text-base font-medium text-white transition duration-200
                        hover:bg-[#004c86] dark:bg-brand-[#004c86] dark:text-white dark:hover:bg-[#004c86]
                        dark:active:bg-[#004c86]" onClick={handleChangePassword}>
                                Reset Password
                            </button>

                            <span className="errorMessage">
                                {errorMessage}
                            </span>
                        </Card>
                    }
                />
            </div>
        </div>


    );
}

export default Verification;
